import _, { castArray, get, isNil, uniqueId } from 'lodash';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form';
import { notification } from 'antd';

export const createNewId = () => {
  return 'NEW' + Date.now();
};

export const isNewId = (id: string | number) => {
  return typeof id === 'string' && id.startsWith('NEW');
};

export const prepareId = (id: string | number) => {
  return isNewId(id) ? null : id;
};

export const indexBy = <D extends { [key: string]: any }, K extends keyof D>(
  array: Array<D>,
  key: K
): Record<string, number> => {
  return array.reduce((result, item, index) => {
    return {
      ...result,
      [item[key]]: index,
    };
  }, {});
};

export const shouldUpdateCompare =
  (key: string | string[]) => (objA: object, objB: object) => {
    return (
      castArray(key).find((k) => get(objA, k) !== get(objB, k)) !== undefined
    );
  };

export const getURLFile = (filename: string, url: string) => {
  const token = localStorage.getItem('token');
  const urlOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      'dev-stage': 'true',
    },
  };
  let fileURL;
  return fetch(url, urlOptions)
    .then((res) => res.blob())
    .then((blob) => {
      if (blob.type === 'text/html') return blob.text().then((res) => res);
      if (blob.type === 'application/pdf') {
        fileURL = window.URL.createObjectURL(blob);

        return fileURL;
      }
      return null as any;
    });
};

export const downloadBlobFile = (filename: string, url: string) => {
  const token = localStorage.getItem('token');
  const urlOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      'dev-stage': 'true',
    },
  };

  return fetch(url, urlOptions)
    .then((res) => res.blob())
    .then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.target = '_blank';
      fileLink.download = filename;
      fileLink.click();
    });
};

export const downloadJSONFile = (data: any, filename: string) => {
  const dataStr =
    'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(data));
  const fileLink = document.createElement('a');
  fileLink.setAttribute('href', dataStr);
  fileLink.setAttribute('download', `${filename}.json`);
  fileLink.click();
};

export const toDatePickerDate = (date?: string) => {
  return date ? moment(date) : '';
};

export const dateToString = (date: any) => {
  if (date === '' || isNil(date)) {
    return '';
  } else {
    return typeof date === 'string' ? date : date.format('YYYY-MM-DD');
  }
};

export const generateId = () => uniqueId('generated-');

export const isGeneratedId = (id: any) =>
  typeof id === 'string' ? id.startsWith('generated-') : false;

export const prepareObjectForApiCall = (object: any) => {
  return Object.keys(object).reduce((result, key) => {
    var value: any = object[key];
    if (key === 'feesFormulaList') {
      value = value.priid;
    }

    if (key === 'feesformula') {
      value = value?.priid;
    }

    if (key === 'tpidbyuer') {
      value = value?.tpid;
    }
    if (key === 'tpparentcompanyid') {
      value = value.tpid;
    }

    return {
      ...result,
      [key]:
        value instanceof moment ? (value as any).format('YYYY-MM-DD') : value,
    };
  }, {});
};

export function unGroup<T>(object: Record<string, T[]>) {
  return Object.keys(object).reduce<T[]>((result, key) => {
    const value: any = object[key];
    if (Array.isArray(value)) {
      return [...result, ...value];
    } else {
      return result;
    }
  }, []);
}

export const customDataPrepareForApiCall = (
  object: any,
  entity: any,
  entityid: any,
  objectreference: any,
  form: FormInstance
) => {
  if (form.getFieldValue('event') === 'tabReschedulingService') {
    let serviceList = form
      .getFieldValue('serviceList')
      .map((serv: any) => {
        return {
          priid: serv.priid,
          prilabel: serv.prilabel,
          servduration: serv.servduration,
          servfixedamount: serv.servfixedamount,
          oldservfixedamount: serv.oldservfixedamount,
          servpercentage: serv.servpercentage,
          oldservpercentage: serv.oldservpercentage,
          cteid: serv.cteid,
          is_new: serv.is_new,
          is_updated: serv.is_updated,
          stop: serv.stop,
          servbasisamount: serv.servbasisamount,
          oldservbasisamount: serv.oldservbasisamount,
          remainingduration: serv.remainingduration,
          oldremainingduration: serv.oldremainingduration,
          overallduration: serv.overallduration,
          oldoverallduration: serv.oldoverallduration,
        };
      })
      .filter((e: any) => e.is_new || e.is_updated || e.stop);

    if (serviceList.length === 0 && form.getFieldValue('mode') === 'SIMUL') {
      notification.error({
        message: 'list service is Empty',
      });
    }
    return {
      offerid: form.getFieldValue('offerid'),
      feesFormula: form.getFieldValue('feesFormula'),
      feesAmount: form.getFieldValue('feesAmount'),
      mode: form.getFieldValue('mode'),
      effectDate: dateToString(form.getFieldValue('effectDate')),
      duree: form.getFieldValue('duree'),
      rental: form.getFieldValue('rental'),
      RemainingDuration: form.getFieldValue('RemainingDuration'),
      serviceList: serviceList,
      comment: '',
      modid: form.getFieldValue('modid'),
    };
  }
  if (form.getFieldValue('event') === 'tabCTPrefinancingClosure') {
    return {
      mode: form.getFieldValue('mode') ?? '',
      modid: form.getFieldValue('modid') ?? 0,
      effectDate: dateToString(form.getFieldValue('effectDate')) ?? '',
      approuvedAmount: form.getFieldValue('approuvedAmount') ?? 0,
      usedAmount: form.getFieldValue('usedAmount') ?? 0,
      totalinvoicedamount: form.getFieldValue('totalinvoicedamount') ?? 0,
      lastinvoicedate: form.getFieldValue('lastinvoicedate') ?? '',
      outstandingamount: form.getFieldValue('outstandingamount') ?? 0,
      lastinvoicamount: form.getFieldValue('lastinvoicamount') ?? 0,
      totalunpaid: form.getFieldValue('totalunpaid') ?? 0,
      totaloutstanding: form.getFieldValue('totaloutstanding') ?? 0,
      calcMethod: form.getFieldValue('calcMethod'),
      offerid: form.getFieldValue('offerid') ?? 0,
      cteduration: form.getFieldValue('cteduration') ?? 0,
      ctegraceperiodduration: form.getFieldValue('ctegraceperiodduration') ?? 0,
      cteperiodicity: form.getFieldValue('cteperiodicity') ?? 0,
      ctegraceperiodmethod: form.getFieldValue('ctegraceperiodmethod') ?? '',
      ctenominalrate: form.getFieldValue('ctenominalrate') ?? 0,
      ctebillingdate: form.getFieldValue('ctebillingdate') ?? '',
      newRentalAmount: form.getFieldValue('newRentalAmount') ?? 0,
      ctervamount: form.getFieldValue('ctervamount') ?? 0,
      comment: form.getFieldValue('comment') ?? '',
      modreason: form.getFieldValue('modreason') ?? '',
      includeTotalInterest: form.getFieldValue('includeTotalInterest') ?? false,
      includeTotalUnpaid: form.getFieldValue('includeTotalUnpaid') ?? false,
      event_process: form.getFieldValue('event_process') ?? '',
      flagTolerance: form.getFieldValue('flagTolerance') ?? false,
      extracost: form.getFieldValue('extracost') ?? 0,
      sifees: form.getFieldValue('sifees') ?? 0,
    };
  }

  if (form.getFieldValue('event') === 'tabLoanEndOfTerm') {
    return {
      comment: form.getFieldValue('comment'),
      modreason: form.getFieldValue('modreason'),
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('objectreference'),
      targetPhase: form.getFieldValue('targetPhase'),
      targetStatus: form.getFieldValue('targetStatus'),
      ctrid: entityid,
      feesFormula: form.getFieldValue('feesFormula')?.priid ?? '',
      feesAmount: form.getFieldValue('feesAmount'),
    };
  }

  if (form.getFieldValue('event') === 'tabMasterFacilityUse') {
    const assetList: any[] = [];
    form.getFieldValue('selectedAssets').forEach((asset: any) => {
      if (asset.selected) {
        assetList.push({
          assetid: asset.assetid,
          assetNetAmount: asset.mfAssetNetAmount,
          assetqty: asset.mfassetqty,
          mfassetqty: asset.mfassetqty,
          mfAssetNetAmount: asset.mfAssetNetAmount,
          assetunitnetamount: asset.assetunitnetamount,
        });
      }
    });

    return {
      ...form.getFieldsValue(),
      selectedAssets: assetList ?? [],
      splitAssets: form.getFieldValue('splitAssets') ?? false,
    };
  }

  if (form.getFieldValue('event') === 'tabAssetServiceUseRequest') {
    return {
      servcode: form.getFieldValue('servcode'),
      requestdate: form.getFieldValue('requestdate'),
      supplierid: form.getFieldValue('supplierid'),
      suppliername: form.getFieldValue('suppliername'),
      supplierreference: form.getFieldValue('supplierreference'),
      requestedamount: form.getFieldValue('requestedamount'),
      associd: form.getFieldValue('associd'),
      assetid: form.getFieldValue('assetid'),
      cteid: form.getFieldValue('cteid'),
      currcode: form.getFieldValue('currcode'),

      requeststatus: form.getFieldValue('requeststatus'),

      requestedqty: form.getFieldValue('requestedqty'),
      acceptedamount: form.getFieldValue('acceptedamount'),
      acceptedqty: form.getFieldValue('acceptedqty'),
      useramounttobeinvoiced: form.getFieldValue('useramounttobeinvoiced'),
      suppliervalidatedamount: form.getFieldValue('suppliervalidatedamount'),
      usecomment: form.getFieldValue('usecomment'),
      externalreference: form.getFieldValue('externalreference'),

      kilometerscounter: form.getFieldValue('kilometerscounter'),
    };
  }

  if (form.getFieldValue('event') === 'TabLoanRescheduling') {
    return {
      comment: form.getFieldValue('comment') ?? '',
      modreason: form.getFieldValue('modreason') ?? '',
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('objectreference'),
      ctrid: entityid,
      effectDate: dateToString(form.getFieldValue('effectDate')),
      newEndDate: dateToString(form.getFieldValue('newEndDate')),
      newRate: form.getFieldValue('newRate'),
      newPartDays: form.getFieldValue('newPartDays') ?? 0,
      flagamortizevat: form.getFieldValue('flagamortizevat') ?? true,
      flaggenpayment: form.getFieldValue('flaggenpayment') ?? false,
      assettaxamount: form.getFieldValue('assettaxamount'),
      newDuration: form.getFieldValue('newDuration') ?? 0,
      newCtFinancedAmount: form.getFieldValue('newCtFinancedAmount') ?? 0,
      newNominalRate: form.getFieldValue('newNominalRate') ?? 0,
      newRateSpread: form.getFieldValue('newRateSpread') ?? 0,
      newRateRef: form.getFieldValue('newRateRef') ?? 0,
      newRateFormula: form.getFieldValue('newRateFormula'),
      newRateType: form.getFieldValue('newRateType'),
      newPeriodicity: form.getFieldValue('newPeriodicity'),
      feesFormula: form.getFieldValue('feesFormula')?.priid ?? '',
      feesAmount: form.getFieldValue('feesAmount') ?? 0,
      mode: form.getFieldValue('mode'),
      modid: form.getFieldValue('modid') ?? 0,
      payOffFormula: form.getFieldValue('flagUpdateAuthorization') ?? false,
      lastInvoiceDate: form.getFieldValue('lastInvoiceDate') ?? '',
      offerid: form.getFieldValue('offerid') ?? 0,
      old_offerid: form.getFieldValue('oldOfferId') ?? 0,
      finassetrequestlist:
        form.getFieldValue('assets')?.map((asset: any) => ({
          assetid: asset?.assetid,
          assetreference: asset.assetreference,
          assetlabel: asset.assetlabel,
          assetnetamount: asset.assetnetamount,
          assetrvamount: asset.assetrvamount,
          finrvamount: asset.finrvamount,
          targetclass: asset.targetclass,
        })) ?? [],
    };
  }

  if (form.getFieldValue('event') === 'tabLoanReimbursment') {
    return {
      comment: form.getFieldValue('comment'),
      reason: form.getFieldValue('reason'),
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('objectreference'),
      ctrid: entityid,
      effectDate: dateToString(form.getFieldValue('effectDate')),
      elemList: form.getFieldValue('elemList'),
      payid: form.getFieldValue('payid'),
      payreference: form.getFieldValue('payreference'),
      paydocdate: dateToString(form.getFieldValue('paydocdate')),
      paymount: form.getFieldValue('paymount'),
      newEnddate: dateToString(form.getFieldValue('newEnddate')),
      newRate: form.getFieldValue('newRate'),
      newDuration: form.getFieldValue('newDuration'),
      invoiceFees: form.getFieldValue('invoiceFees'),
      feesFormula: form.getFieldValue('feesFormula') ?? '',
      feesAmount: form.getFieldValue('feesAmount') ?? 0,
      mode: form.getFieldValue('mode'),
      modid: form.getFieldValue('modid'),
      targetStatus: form.getFieldValue('targetStatus'),
      payOffFormula: form.getFieldValue('payOffFormula') ?? '',
      payOffAmount: form.getFieldValue('payOffAmount') ?? 0,
      intereststoinvoice: form.getFieldValue('intereststoinvoice') ?? 0,
      payOffFeesAmount: form.getFieldValue('payOffFeesAmount') ?? 0,
    };
  }
  if (form.getFieldValue('event') === 'tabProposalActivation') {
    return {
      comment: form.getFieldValue('comment'),
      reason: form.getFieldValue('reason'),
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('objectreference'),
      elemDescription: form.getFieldValue('elemDescription'),
      investAmount: form.getFieldValue('investAmount'),
      startDate: dateToString(form.getFieldValue('startDate')),
      generateDisbursment: form.getFieldValue('generateDisbursment') ?? false,
      ActivationMode: form.getFieldValue('activationMode'),
      prefinrateref: form.getFieldValue('prefinrateref'),
      prefinratespread: form.getFieldValue('prefinratespread'),
      prefinnominalrate: form.getFieldValue('prefinnominalrate'),
    };
  }

  if (form.getFieldValue('event') === 'tabSplitFinAssetOrComponent') {
    return {
      flagsplitComponent: form.getFieldValue('flagsplitComponent') ?? false,
      ctrid: form.getFieldValue('ctrid'),
      qty: form.getFieldValue('qty') ?? 0,
    };
  }

  if (form.getFieldValue('event') === 'tabSplitAssetInit') {
    return {
      flagsplitComponent: form.getFieldValue('flagsplitComponent') ?? false,
      ctrid: form.getFieldValue('ctrid'),
      qty: form.getFieldValue('qty') ?? 0,
    };
  }

  if (form.getFieldValue('event') === 'TabContractTransfer') {
    return {
      comment: form.getFieldValue('comment'),
      reason: form.getFieldValue('reason'),
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('objectreference'),
      tpidOldClient: form.getFieldValue('tpidOldClient')?.tpid,
      tpidNewClient: form.getFieldValue('tpidNewClient')?.tpid,
      tpadridNewClient: form.getFieldValue('tpadridNewClient'),
      tpbkidNewClient: form.getFieldValue('tpbkidNewClient'),
      feesFormula: form.getFieldValue('feesFormula')?.priid ?? 0,
      feesTax: 0,
      feesTaxcode:
        form.getFieldValue('feesFormula')?.serviceResponse?.taxcode ?? '',
      feesTaxrate: 0,
      feestype:
        form.getFieldValue('feesFormula')?.serviceResponse?.servcode ?? '',
      feescategory:
        form.getFieldValue('feesFormula')?.serviceResponse?.servcode ?? '',

      feesAmount: form.getFieldValue('feesAmount') ?? 0,
      mode: form.getFieldValue('mode'),
      modid: form.getFieldValue('modid'),
      tpnameold:
        form.getFieldValue('tpidOldClient')?.tpreference +
        ' - ' +
        form.getFieldValue('tpidOldClient')?.tpname,
      tpnamenew:
        form.getFieldValue('tpidNewClient')?.tpreference +
        ' - ' +
        form.getFieldValue('tpidNewClient')?.tpname,
      adrnew: form.getFieldValue('adrnew'),
      bknew: form.getFieldValue('bknew'),
    };
  }

  if (form.getFieldValue('event') === 'tabParListActivation') {
    return {
      newparvalue: form.getFieldValue('newparvalue'),
      parvalue: form.getFieldValue('parvalue'),
      parcode: form.getFieldValue('parcode'),
      promtype: form.getFieldValue('reason'),
      flagaction: form.getFieldValue('flagreplace'),
      comment: form.getFieldValue('comment'),
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('objectreference'),
    };
  }
  if (form.getFieldValue('event') === 'tabContractChangeBK') {
    return {
      tpid: form.getFieldValue('tpid'),
      tprolecode: form.getFieldValue('tprolecode'),
      feestype: form.getFieldValue('feestype') ?? '',
      feesTaxrate: form.getFieldValue('feesTaxrate') ?? 0,
      feesTaxcode: form.getFieldValue('feesTaxcode') ?? '',
      feescategory: form.getFieldValue('feescategory') ?? '',
      feesAmount: form.getFieldValue('feesAmount') ?? 0,
      feesFormula: form.getFieldValue('feesFormula') ?? '',
    };
  }

  if (form.getFieldValue('event') === 'tabContractChangeADR') {
    return {
      tpid: form.getFieldValue('tpid'),
      rolcode: form.getFieldValue('rolcode'),
      feestype: form.getFieldValue('feestype') ?? '',
      feesTaxrate: form.getFieldValue('feesTaxrate') ?? 0,
      feesTaxcode: form.getFieldValue('feesTaxcode') ?? '',
      feescategory: form.getFieldValue('feescategory') ?? '',
      feesAmount: form.getFieldValue('feesAmount') ?? 0,
      feesFormula: form.getFieldValue('feesFormula') ?? '',
    };
  }

  if (form.getFieldValue('event') === 'tabAssetAttributeActivation') {
    return {
      promtype: form.getFieldValue('attcode'),
      parvalue: form.getFieldValue('reason'),
      rolcode: form.getFieldValue('tprolecode'),
      flagaction: form.getFieldValue('flagreplace'),
      comment: form.getFieldValue('comment'),
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('objectreference'),
    };
  }

  if (form.getFieldValue('event') === 'tabAssetFvDuplicate') {
    return {
      promtype: form.getFieldValue('contextcode'),
      parvalue: form.getFieldValue('reason'),
      flagaction: form.getFieldValue('flagreplace'),
      comment: form.getFieldValue('comment'),
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('objectreference'),
    };
  }

  if (form.getFieldValue('event') === 'tabUpadteDateMandat') {
    return {
      subentityid: form.getFieldValue('subentityid'),
      mandatedate: moment(form.getFieldValue('mandatedate')).isValid()
        ? moment(form.getFieldValue('mandatedate')).format('YYYY-MM-DD')
        : null,
    };
  }

  if (form.getFieldValue('event') === 'tabUpdateAssetRegistrationData') {
    return {
      currcode: form.getFieldValue('currcode'),
      entityId: entityid,
      entity: entity,
      objectreference: form.getFieldValue('assetreference'),
      chassisno: form.getFieldValue('chassisno'),
      engineno: form.getFieldValue('engineno'),
      plateno: form.getFieldValue('plateno'),
      power: form.getFieldValue('power'),
      registrationno: form.getFieldValue('registrationno'),
      serialno: form.getFieldValue('serialno'),
      weight: form.getFieldValue('weight'),
      registrationdate: dateToString(form.getFieldValue('registrationdate')),
      registrationcity: form.getFieldValue('registrationcity'),
      registrationname: form.getFieldValue('registrationname'),
      fiscalpower: form.getFieldValue('fiscalpower'),
      firstregistrationdate: dateToString(
        form.getFieldValue('firstregistrationdate')
      ),
    };
  }

  if (form.getFieldValue('event') === 'tabAssetActivation') {
    return {
      listAsset: form.getFieldValue('listAsset'),
      generateDisbursment: form.getFieldValue('generateDisbursment') ?? false,
    };
  }

  if (form.getFieldValue('event') === 'tabAssetDelivery') {
    return {
      listAsset: form.getFieldValue('listAsset'),
      deliveryDate: moment(form.getFieldValue('deliveryDate')).format(
        'YYYY-MM-DD'
      ),
      deliveryReference: form.getFieldValue('deliveryReference'),
      effectDate: moment(form.getFieldValue('effectDate')).format('YYYY-MM-DD'),
    };
  }
  if (form.getFieldValue('event') === 'tabTPChangeAddress') {
    return {
      flagapplytoall: form.getFieldValue('flagapplytoall') ?? false,
      tpadrid: form.getFieldValue('tpadrid') ?? 0,
    };
  }

  if (form.getFieldValue('event') === 'tabAddTp') {
    return {
      tpid: form.getFieldValue('tpid').tpid,
      tpname: form.getFieldValue('tpid').tpname,
      tpreference: form.getFieldValue('tpid').tpreference,
      status: form.getFieldValue('tpid').tpstatus,
      tpadrid: form.getFieldValue('address'),
    };
  }

  if (form.getFieldValue('event') === 'tabSaveAssetAsCatalog') {
    return {
      currcode: form.getFieldValue('currcode'),
      entityId: entityid,
      entity: entity,
      comment: form.getFieldValue('assetdescription'),
      externalreference: form.getFieldValue('assetlabel'),
    };
  }

  if (form.getFieldValue('event') === 'tabScoring') {
    return {
      currcode: form.getFieldValue('currcode'),
      entityId: entityid,
      entity: entity,
      gridid: form.getFieldValue('gridid'),
      referenceyear: form.getFieldValue('referenceyear'),
      requestedamount: form.getFieldValue('requestedamount'),
      tpid: form.getFieldValue('tpid'),
      tpname: form.getFieldValue('tpname'),
      tpreference: form.getFieldValue('tpreference'),
      tprole: form.getFieldValue('tprole'),
    };
  }

  if (form.getFieldValue('event') === 'tabTpAuthorizationUse') {
    return {
      tpidbeneficiairy: entityid,
      prcode: form.getFieldValue('prcode'),
      offerid: form.getFieldValue('offerid'),
      amountToUse: form.getFieldValue('amountToUse'),
      beneficiaryname: form.getFieldValue('beneficiaryname'),
      beneficiaryreference: form.getFieldValue('beneficiaryreference'),
      ofrtype: form.getFieldValue('ofrtype'),
      ofrid: form.getFieldValue('ofrid'),
      authid: form.getFieldValue('authid'),
      authdetailid: form.getFieldValue('authdetailid'),
      nominalrate: form.getFieldValue('nominalrate'),
      ratespread: form.getFieldValue('ratespread'),
      rateref: form.getFieldValue('rateref'),
      rateformula: form.getFieldValue('rateformula'),
      ratetype: form.getFieldValue('ratetype'),
      calculationtype: form.getFieldValue('calculationtype'),
      periodicity: form.getFieldValue('periodicity'),
      duration: form.getFieldValue('duration'),
      startDate: dateToString(form.getFieldValue('startDate')),
      endDate: dateToString(form.getFieldValue('endDate')),
      usecomment: form.getFieldValue('usecomment'),
      assets: form.getFieldValue('assets') ?? [],
      prefinStepsList: form.getFieldValue('_prefinStepsList') ?? [],
      prefinmethod: form.getFieldValue('prefinmethod'),
      ctepartmethod: form.getFieldValue('ctepartmethod'),
      ctepartamount: form.getFieldValue('ctepartamount'),
      ctepartrate: form.getFieldValue('ctepartrate'),
      ctepartdays: form.getFieldValue('ctepartdays'),
      tpidparticipation: form.getFieldValue('tpidparticipation'),
    };
  }

  if (form.getFieldValue('event') === 'TabEvAuthorization') {
    return {
      authDetail: form.getFieldValue('authDetail'),
      tpid: form.getFieldValue('tpid'),
      authtype: form.getFieldValue('authtype'),
      creationdate: form.getFieldValue('creationdate'),
      useridcreation: form.getFieldValue('useridcreation'),
      startdate: form.getFieldValue('startdate'),
      enddate: form.getFieldValue('enddate'),
      authstatus: form.getFieldValue('authstatus'),
      authstatusdate: form.getFieldValue('authstatusdate'),
      authamount: form.getFieldValue('authamount'),
      currcode: form.getFieldValue('currcode'),
      proctaskid: form.getFieldValue('proctaskid'),
      authbookedamount: form.getFieldValue('authbookedamount'),
      authusedamount: form.getFieldValue('authusedamount'),
      authavailableamount: form.getFieldValue('authavailableamount'),
      authcalculatedamount: form.getFieldValue('authcalculatedamount'),
      scoid: form.getFieldValue('scoid'),
      authcomment: form.getFieldValue('authcomment'),
      authtolerance: form.getFieldValue('authtolerance') ?? 0,
      authusedamountalert: form.getFieldValue('authusedamountalert') ?? 0,
      authflagtransfer: form.getFieldValue('authflagtransfer') ?? false,
    };
  }

  if (form.getFieldValue('event') === 'tabfinmodificationrestore') {
    const eventValue = form.getFieldValue('modevent');
    return {
      comment: form.getFieldValue('comment'),
      event:
        Array.isArray(eventValue) && eventValue.length === 1
          ? eventValue[0]
          : eventValue,
      modid: form.getFieldValue('modid'),
    };
  }

  if (form.getFieldValue('event') === 'tabpreparedAssetForDelivery') {

    const newAssets = form.getFieldValue('assetList')?.map((asset: any) => {

        const isoString = String(asset.assetdeliverytime);
        const formattedTime = moment(isoString).format('HH:mm');

        let assetUsers = {
          assetname: asset?.assetUsers?.assetname,
          relvalue: asset?.assetUsers?.relvalue,
          assetrelid: asset?.assetUsers?.assetrelid,
          assetid: asset?.assetUsers?.assetid,
          creationdate: asset?.assetUsers?.creationdate,
          startdate: asset.startdate ? asset.startdate.format('YYYY-MM-DD')+"T"+formattedTime: "",
          enddate: asset?.assetUsers?.enddate,
          relcode: asset?.assetUsers?.relcode,
          reltype: asset?.assetUsers?.reltype,
          relvaluenew: asset?.assetUsers?.relvaluenew,
          tpidtarget: asset?.assetUsers?.tpidtarget,
          tptargetname: asset?.assetUsers?.tptargetname,
          updatedate: asset?.assetUsers?.updatedate,
          useridcreate: asset?.assetUsers?.useridcreate,
          useridupdate: asset?.assetUsers?.useridupdate
        };

        return {
            assetUsers,
            assetid:asset.assetid,
            assetstatus: asset.assetstatus,
            assetlabel: asset.assetlabel,
            plateno: asset.plateno,
            chassisno: asset.chassisno,
            serialno: asset.serialno,
            flagused: asset.flagused,
            deliveryadrstreet1: form.getFieldValue('deliveryadrstreet1'),
            deliveryadrstreet2: form.getFieldValue('deliveryadrstreet2'),
            deliveryadrcity: form.getFieldValue('deliveryadrcity'),
            deliveryadrzipcode: form.getFieldValue('deliveryadrzipcode'),
            deliveryadrcountry: form.getFieldValue('deliveryadrcountry'),
            deliveryadrregion: form.getFieldValue('deliveryadrregion'),
            assetdeliverydate: asset.startdate ? asset.startdate.format('YYYY-MM-DD')+"T"+formattedTime: "",
            firstregistrationdate: asset.firstregistrationdate,
            registrationcity: asset.registrationcity,
            registrationdate: asset.registrationdate,
            registrationname: asset.registrationname,
            registrationno: asset.registrationno,
            weight: asset.weight,
            fiscalpower: asset.fiscalpower,
            engineno: asset.engineno
        };
    });

    return {
        assetList: newAssets,
    };
  }
  if (form.getFieldValue('event') === 'tabAddFinAssetFees') {

    let supplier= form.getFieldValue('supplier');

    return {
      tpidsupplier: supplier.tpid,
      supplier:{
        tpid: supplier.tpid,
        tpname: supplier.tpname,
        tpreference: form.getFieldValue('tpreference'),
        sitype: "FEES",
        sistatus: "INIT",
        tptype: supplier.tptype,
        tpstatus: supplier.tpstatus,
        tagroles: supplier.tagroles,
        mgid: supplier.mgid,
        currcode: supplier.currcode,
        tpfiscalid: supplier.tpfiscalid,
        ctrid: supplier.ctrid ?? form.getFieldValue('ctrid'),
        ctreference: supplier.ctreference ?? form.getFieldValue('ctreference'),  
        sitaxtotal: supplier.feestaxamount ?? form.getFieldValue('feestaxamount'),
        sinettotal: supplier.feesnetamount ?? form.getFieldValue('feesnetamount'),
        sigrosstotal: supplier.fessgrossamount ?? form.getFieldValue('fessgrossamount'),
        sidueamount: supplier.fessgrossamount ?? form.getFieldValue('fessgrossamount'),
        tpidsupplier: supplier.tpid,
        sidocdate: moment().toISOString(),
        SuppInvoiceLines: [
          {
            sildiscountperc: form.getFieldValue('feesdiscountrate'),
            ctrid: supplier.ctrid ?? form.getFieldValue('ctrid'),
            siltaxrate: form.getFieldValue('taxrate'),
            sildescription: form.getFieldValue('feestype'),
            silcategory: form.getFieldValue('feescategory'),
            siltype: "FEES",
            silnettotalamount: form.getFieldValue('feesnetamount'),
            silgrosstotalamount: form.getFieldValue('fessgrossamount'),
            siltaxtotalamount: form.getFieldValue('feestaxamount'),
            assetid: form.getFieldValue('assetid')
          }
        ],
        SuppInvoiceSchedules: [
          {
            sispaymentmode: supplier.SuppInvoiceSchedules.sispaymentmode ?? form.getFieldValue('sispaymentmode'),
            sispaymentdelaycode: supplier.SuppInvoiceSchedules.sispaymentdelaycode ?? form.getFieldValue('sispaymentdelaycode'),
            sistype: "PAYMENT",
            tpidbeneficiary: supplier.SuppInvoiceSchedules.tpidbeneficiary ?? form.getFieldValue('tpidbeneficiary'),
            tpbeneficiarybankaccount: supplier.SuppInvoiceSchedules.tpbeneficiarybankaccount ?? form.getFieldValue('tpbeneficiarybankaccount'),
            sisstatus: "INIT",
            sisamount: form.getFieldValue('fessgrossamount'),
            sisdueamount: form.getFieldValue('fessgrossamount')
          }
        ]
      },
      DocumentList: form.getFieldValue('DocumentList'),
    };
  }


  if (
    object?.elements !== undefined &&
    Object.keys(object?.elements).length !== 0
  ) {
    const allElem = unGroup(object?.elements);
    const oldData = object?.olddata;
    return {
      finModElementReschedulingRequest: allElem.map((ele: any) => {
        const oldelem = oldData?.find((elem: any) => elem.cteid === ele.cteid);

        let finModSimulParams = [];

        if (oldelem?.ctecalculationtype !== ele?.ctecalculationtype)
          finModSimulParams.push({
            grossamount: 0,
            newvalue: ele?.ctecalculationtype,
            oldvalue: oldelem?.ctecalculationtype,
            paramid: 0,
            parcode: 'CALMETHOD',
            partype: 'IN',
            taxamount: 0,
            taxcode: '',
            taxrate: 0,
            finModSimulParamSteps: [],
          });
        if (oldelem?.cteduration !== ele?.cteduration)
          finModSimulParams.push({
            grossamount: 0,
            newvalue: ele?.cteduration,
            oldvalue: oldelem?.cteduration,
            paramid: 0,
            parcode: 'DURATION',
            partype: 'IN',
            taxamount: 0,
            taxcode: '',
            taxrate: 0,
            finModSimulParamSteps: [],
          });
        if (oldelem?.ctenominalrate !== ele?.ctenominalrate)
          finModSimulParams.push({
            grossamount: 0,
            newvalue: ele?.ctenominalrate,
            oldvalue: oldelem?.ctenominalrate,
            paramid: 0,
            parcode: 'RATE',
            partype: 'IN',
            taxamount: 0,
            taxcode: '',
            taxrate: 0,
            finModSimulParamSteps: [],
          });

        if (oldelem?.ctervamount !== ele?.ctervamount)
          finModSimulParams.push({
            grossamount: 0,
            newvalue: ele?.ctervamount,
            oldvalue: oldelem?.ctervamount,
            paramid: 0,
            parcode: 'RV',
            partype: 'IN',
            taxamount: 0,
            taxcode: '',
            taxrate: 0,
            finModSimulParamSteps: [],
          });

        if (oldelem?.cteperiodicity !== ele?.cteperiodicity)
          finModSimulParams.push({
            grossamount: 0,
            newvalue: ele?.cteperiodicity,
            oldvalue: oldelem?.cteperiodicity,
            paramid: 0,
            parcode: 'PERIOD',
            partype: 'IN',
            taxamount: 0,
            taxcode: '',
            taxrate: 0,
            finModSimulParamSteps: [],
          });
        if (oldelem?.cteunit !== ele?.cteunit)
          finModSimulParams.push({
            grossamount: 0,
            newvalue: ele?.cteunit,
            oldvalue: oldelem?.cteunit,
            paramid: 0,
            parcode: 'UNIT',
            partype: 'IN',
            taxamount: 0,
            taxcode: '',
            taxrate: 0,
            finModSimulParamSteps: [],
          });
        if (!_.isEqual(oldelem?.conElemSteps, ele?.conElemSteps))
          finModSimulParams.push({
            grossamount: 0,
            newvalue: '',
            oldvalue: '',
            paramid: 0,
            parcode: 'STEP',
            partype: 'IN',
            taxamount: 0,
            taxcode: '',
            taxrate: 0,
            finModSimulParamSteps: ele?.conElemSteps,
          });

        return {
          ctebilligdate: ele.ctebilligdate,
          ctecalculationtype: ele.ctecalculationtype,
          cteduration: ele.cteduration,
          ctefirstpayment: ele.ctefirstpayment,
          cteid: ele.cteid,
          cteinstallmentamount: ele.cteinstallmentamount,
          ctenominalrate: ele.ctenominalrate,
          cteoutstandingamount: ele.cteoutstandingamount,
          cteperiodicity: ele.cteperiodicity,
          cterentalamount: ele.cterentalamount,
          ctervamount: ele.ctervamount,
          cteunit: ele.cteunit,
          finModSimulParams: finModSimulParams,
          flagStop: ele.flagStop,
        };
      }),
    };
  } else if (entity === 'FINASSET' && !isNil(object.assetToSaleList)) {
    const newAssets = object.assetToSaleList?.map((asset: any) => {
      return {
        assetdescription: asset.assetlabel,
        assetid: asset.assetid,
        assetoutnetamount: asset.assetoutnetamount,
        assetouttaxcode: asset.assetouttaxcode,
        effectdate: dateToString(asset.effectdate),
      };
    });
    return {
      assetToSaleList: newAssets,
      effectdate: dateToString(object.effectdate),
      tpidbyuer:
        typeof object.tpidbyuer === 'object'
          ? object.tpidbyuer.tpid
          : object.tpidbyuer,
    };
  } else if (entity === 'THIRDPARTY') {
    return {
      countcode: form.getFieldValue('countcode'),
    };
  } else if (
    form.getFieldValue('clientInvoiceScheduleViewList') &&
    !isNil(form.getFieldValue('clientInvoiceScheduleViewList'))
  )
    return {
      clientInvoiceScheduleViewList: form
        .getFieldValue('clientInvoiceScheduleViewList')
        .map((line: any) =>
          _.pick(
            {
              ...line,
              ciid: entityid,
              cisid: line.new ? null : line.cisid,
              tpbkid: line.tppayerbankaccount,
              cisduedate: moment(line.cisduedate).format('YYYY-MM-DD'),
            },
            [
              'ciid',
              'cisamount',
              'cisdueamount',
              'cisduedate',
              'cisid',
              'cisorder',
              'cispaymentdelaycode',
              'cispaymentmode',
              'cisstatus',
              'cistype',
              'mgbankaccount',
              'tpidpayer',
              'tppayerbankaccount',
              'tpbkid',
            ]
          )
        ),
    };
  else if (
    form.getFieldValue('suppInvoiceScheduleViewList') &&
    !isNil(form.getFieldValue('suppInvoiceScheduleViewList'))
  ) {
    return {
      suppInvoiceScheduleViewList: form
        .getFieldValue('suppInvoiceScheduleViewList')
        .map((line: any) =>
          _.pick(
            {
              ...line,
              siid: entityid,
              sisid: line.new ? null : line.sisid,
              tpbkid: line.tpbeneficiarybankaccount,
            },
            [
              'mgbankaccount',
              'siid',
              'sisamount',
              'siscategory',
              'sisdueamount',
              'sisduedate',
              'sisid',
              'sislabel',
              'sisorder',
              'sispaymentdelaycode',
              'sispaymentmode',
              'sispercentage',
              'sisstatus',
              'sistype',
              'tpbeneficiarybankaccount',
              'tpidbeneficiary',
              'tpbkid',
            ]
          )
        ),
    };
  } else if (form.getFieldValue('event') === 'tabCTEarlyTerm') {
    const newAssets = form.getFieldValue('listAssets')?.map((asset: any) => {
      return {
        assetlabel: asset.assetlabel,
        assetid: asset.assetid,
        assetreference: asset.assetreference,
        assetnetamount: asset.assetnetamount,
        assetrvamount: asset.assetrvamount,
        finrvamount: asset.finrvamount,
        rentalpart: asset.rentalpart,
        capitalpart: asset.capitalpart,
        irvamount: asset.irvamount,
        rvgap: asset.rvgap,
        targetphase: asset.targetphase,
        targetstatus: asset.targetstatus,
        damage: asset.damage,
        degfeesformula: asset.degfeesformula,
        degfeesformulalabel: asset.degfeesformulalabel,
        degfeesamount: asset.degfeesamount,
        spvalue: asset.spvalue,
        spformula: asset.spformula,
        spformulalabel: asset.spformulalabel,
        spamount: asset.spamount,
        saleamount: asset.saleamount,
        tpofformula: asset.tpofformula,
        tpofformulalabel: asset.tpofformulalabel,
        tpofamount: asset.tpofamount,
        totalinvoiceamount: asset.totalinvoiceamount,
        effectDate: dateToString(form.getFieldValue('effectDate')),
        fees: asset.fees,
        feesamount: asset?.feesamount,
        feeslabel: asset?.feeslabel,
      };
    });

    return {
      assetList: newAssets,
      flagapplytoall: form.getFieldValue('flagapplytoall') ?? null,
      mode: form.getFieldValue('mode') ?? null,
      targetphase: form.getFieldValue('targetphase') ?? null,
      targetstatus: form.getFieldValue('targetstatus') ?? null,
      modid: form.getFieldValue('modid') ?? null,
      totalfinrvamount: form.getFieldValue('totalfinrvamount') ?? null,
      totalirvamount: form.getFieldValue('totalirvamount') ?? null,
      damage: form.getFieldValue('damage') ?? null,
      degfeesformula: form.getFieldValue('degfeesformula')?.priid ?? null,
      degfeesformulalabel:
        form.getFieldValue('degfeesformula')?.prilabel ?? null,

      spvalue: form.getFieldValue('spvalue') ?? null,
      spformula: form.getFieldValue('spformula')?.priid ?? null,
      spformulalabel: form.getFieldValue('spformula')?.prilabel ?? null,

      tpofformula: form.getFieldValue('tpofformula')?.priid ?? null,
      tpofformulalabel: form.getFieldValue('tpofformula')?.prilabel ?? null,

      currentRental: form.getFieldValue('currentRental') ?? null,
      currentOutstanding: form.getFieldValue('currentOutstanding') ?? null,
      currentRV: form.getFieldValue('currentRV') ?? null,

      newOutstanding: form.getFieldValue('newOutstanding') ?? null,
      newRental: form.getFieldValue('newRental') ?? null,
      newRV: form.getFieldValue('newRV') ?? null,
      newRv: form.getFieldValue('newRv') ?? null,
      fees: {
        label: form.getFieldValue('feeslabel') ?? null,
        value:
          typeof form.getFieldValue('fees') == 'object'
            ? form.getFieldValue('fees').value
            : form.getFieldValue('fees'),
        key: 0,
      },
      feesamount: Number(form.getFieldValue('feesamount')) ?? 0,
    };
  } else if (
    form.getFieldValue('promcomment') &&
    !isNil(form.getFieldValue('promcomment'))
  ) {
    if (
      form.getFieldValue('promtype') &&
      !isNil(form.getFieldValue('promtype'))
    ) {
      return {
        ...form.getFieldsValue(),
        ciid: form.getFieldValue('ciid'),
        userid: Number(localStorage.getItem('userid')) ?? 0,
      };
    } else {
      return {
        ...form.getFieldsValue(),
        promcreationdate: moment(),
        promstatus: 'ACTIVE',
        promstatusdate: moment(),
        promdate: moment(),
        clientinvoice: 0,
        promamount: 0,
        promtype: 'COMMENT',
        userid: Number(localStorage.getItem('userid')) ?? 0,
        ciid: 0,
      };
    }
  } else if (form.getFieldValue('event') === 'TabEvaluateAsset') {
    return {
      assetid: entityid,
      repdecision: form.getFieldValue('repdecision'),
      repevaldate: form.getFieldValue('repevaldate'),
      assetfinrvamount: form.getFieldValue('assetfinrvamount'),
      assetirvamount: form.getFieldValue('assetirvamount'),
      marketvalue: form.getFieldValue('marketvalue'),
      marketvaluedate: form.getFieldValue('marketvaluedate'),
      marketvalueorigin: form.getFieldValue('marketvalueorigin'),
      damage: form.getFieldValue('damage'),
      recondamount: form.getFieldValue('recondamount'),
      transportamount: form.getFieldValue('transportamount'),
      storageamount: form.getFieldValue('storageamount'),
      marketvalueasis: form.getFieldValue('marketvalueasis'),
      saleamount: form.getFieldValue('saleamount'),
      gainifrecond: form.getFieldValue('gainifrecond'),
      gainifsale: form.getFieldValue('gainifsale'),
      repcomment: form.getFieldValue('repcomment'),
      spvalue: form.getFieldValue('spvalue'),
      spformula: form.getFieldValue('spformula'),
      spamount: form.getFieldValue('spamount'),
      actulamileage: form.getFieldValue('actualmileage'),
      contractualmileage: form.getFieldValue('contractualmileage')
    };
  } else if (form.getFieldValue('event') === 'tabAddmarketvalue') {
    return {
      assetid: entityid,
      flagupdatefv: form.getFieldValue('flagupdatefv'),
      mvid: 0,
      mvsource: form.getFieldValue('mvsource'),
      proctaskid: 0,
      startdate: form.getFieldValue('startdate'),
      valueamount: form.getFieldValue('valueamount'),
    };
  } else if (form.getFieldValue('event') === 'tabAddAssetUse') {
    let useValues = form.getFieldValue('listData').map((el: any) => ({
      assetid: el.assetid,
      attcode: el.attcode,
      creationdate: moment().format('YYYY-MM-DD'),
      flagupdatefv: false,
      flagupdatemv: false,
      newmarketvalue: el.newmarketvalue,
      proctaskid: 0,
      useid: el.useid,
      useridcreation: Number(localStorage.getItem('userid')) ?? 0,
      usevalue: el.newusevalue,
      usevaluedate: !isNil(el.newusevaluedate)
        ? dateToString(el.newusevaluedate)
        : '',
      valueid: 0,
    }));
    return {
      assetid: entityid,
      flagupdatefv: form.getFieldValue('flagupdatefv') ?? false,
      flagupdatemv: form.getFieldValue('flagupdatemv') ?? false,
      mvsource: form.getFieldValue('mvsource') ?? '',
      newmarketvalue: form.getFieldValue('newmarketvalue') ?? 0,
      newmarketvaluedate: !isNil(form.getFieldValue('newmarketvaluedate'))
        ? dateToString(form.getFieldValue('newmarketvaluedate'))
        : '',
      useValues: useValues,
    };
  } else {
    return {
      objectreference: objectreference,
    };
  }
};
export const setValueByNamePath = (
  form: FormInstance,
  namePath: (string | number)[],
  value: string | number | null | object | boolean
) => {
  const [valuesKey, index, fieldName] = namePath;
  const values = form.getFieldValue(valuesKey);
  values[index][fieldName] = value;
  form.setFieldsValue({ valuesKey: values });
};

export const objectParValueToString = (parvalue: any) => {
  if (typeof parvalue === 'object') {
    return parvalue?.value;
  }
  return parvalue;
};

export const objectLabelToString = (parvalue: any) => {
  if (typeof parvalue === 'object') {
    return parvalue?.label;
  }
  return parvalue;
};

export const NormalizeOnlyAlph = (
  value: string,
  prevvalue?: any,
  allvalues?: any,
  max: number = 10
) => {
  if (/^[a-zA-Z]+$/.test(value) && value.length <= max)
    return value.toUpperCase();
  else if (/^[a-zA-Z]+$/.test(value.slice(0, value.length - 1)))
    return value.slice(0, value.length - 1);
  else return '';
};

export const NormalizeAlphAndNum = (
  value: string,
  prevvalue?: any,
  allvalues?: any,
  max: number = 10
) => {
  if (/^[a-zA-Z0-9]+$/.test(value) && value.length <= max)
    return value.toUpperCase();
  else if (/^[a-zA-Z0-9]+$/.test(value.slice(0, value.length - 1)))
    return value.slice(0, value.length - 1);
  else return '';
};
export const OnlyIntegerNumber = (
  value: string,
  prevvalue?: any,
  allvalues?: any,
  max: number = 13
) => {
  if (/^[0-9]+$/.test(value) && value.length <= max) return value;
  else if (/^[0-9]+$/.test(value.slice(0, value.length - 1)))
    return value.slice(0, value.length - 1);
  else return '';
};

export const ibanValidator = (iban: string) => {
  let rib = iban?.substring(iban?.length - 24);
  let result =
    97 -
    (Number(
      String(
        Number(String(Number(rib?.slice(0, 8)) % 97) + rib?.slice(8, 16)) % 97
      ) +
        rib?.slice(16, 22) +
        '00'
    ) %
      97);

  let isValidate = result === Number(rib?.slice(22, 24));

  return isValidate;
};
export const calculateDate = (
  prefinStepList: any[],
  _lctesstartdate?: string
) => {
  // Ensure a valid initial start date
  let lctesstartdate = _lctesstartdate || moment().format('YYYY-MM-DD');
  let lctesenddate = moment(lctesstartdate)
    .add(prefinStepList[0]?.ctesduration || 0, 'days')
    .format('YYYY-MM-DD');

  const newData = _.orderBy(prefinStepList ?? [], 'ctesorder', 'asc').map(
    (step, index) => {
      if (index > 0) {
        // The next step's start date should be the day after the previous step's end date
        lctesstartdate = moment(lctesenddate)
          .add(1, 'day')
          .format('YYYY-MM-DD');

        // Calculate the end date based on the start date and the duration of the step
        lctesenddate = moment(lctesstartdate)
          .add(step.ctesduration, 'days')
          .format('YYYY-MM-DD');
      }

      return {
        ...step,
        ctesstartdate: lctesstartdate,
        ctesenddate: lctesenddate,
        enddate: lctesenddate,
      };
    }
  );

  return newData;
};
